import { MenuItem, styled } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)<{ underline?: boolean }>(({ theme, underline = true }) => ({
    padding: '10px 16px',
    '&::after': {
        position: 'absolute',
        bottom: 0,
        content: '""',
        width: '90%',
        borderTopWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette['neutral-450'].main,
        display: underline ? 'block' : 'none',
        left: 0,
        right: 0,
        margin: '0 auto',
    },
    '&:last-child::after': {
        display: 'none',
    },
}));
